/** 典型应用详情弹窗的实例标识，供 SSR 视图与前台脚本共用 */
export const SOLUTION_MODAL_ID = "solution-detail";
